<template>
  <div class="page-content">
    <div class="content">
      <table-content :columns='columns' :tableData="tableData" :deleteIsNeed='false' @handleEdit='handleEdit' optionWidth='80'>
        <template #from>
          <el-form :inline="true" :model="filters" :size="size" @keyup.enter.native="handleQuery" @submit.native.prevent>
            <el-form-item>
              <el-select v-model="filters.companyId" placeholder="请选择" filterable clearable >
                <el-option label="全部公司" :value="0" ></el-option>
                <el-option v-for="item in allCompany" :key="item.value" :label="item.name" :value="item.id" ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button :size="size" type="primary" @click="handleQuery">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button :size="size" type="primary" @click="handleAdd">新增</el-button>
            </el-form-item>
          </el-form>
        </template>
      </table-content>
    </div>
    <add-or-update ref="addOrUpdate" v-if="addOrUpdateVisible" :companyList="allCompany" @handleQuery='handleQuery'></add-or-update>
  </div>
</template>

<script>
import addOrUpdate from './addOrUpdate.vue'
import tableContent from './tableContent.vue'
export default {
  components: {
    addOrUpdate,
    tableContent
  },
  data () {
    return {
      clientContactInfoVisible: false,
      projectConfigVisible: false,
      addOrUpdateVisible: false,
      size: 'small',
      contactList: [],
      allCompany: [],
      filters: {
        companyId: 0,
        ProjectIds: []
      },
      columns: [
        { prop: 'projectName', label: '项目名称', minWidth: 200 },
        { prop: 'workBaseName', label: '匹配基地站', minWidth: 200 }
      ],
      tableData: []
    }
  },
  created () {
    this.$api.contract.getListAllCompany().then((res) => {
      if (res.success) {
        this.allCompany = res.data
      }
    })
    this.handleQuery()
  },
  methods: {
    handleQuery () {
      this.$api.electricOperations.listElectricOperationsWorkOrderDispatchingPriorityRegulation({
        ...this.filters
      }).then((res) => {
        if (res.success) {
          this.tableData = res.data
        }
      })
    },
    handleAdd () {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(null)
      })
    },
    handleEdit (params) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(params.row)
      })
    },
    handleProjectConfig (params) {
      console.log(params)
      this.projectConfigVisible = true
      this.$nextTick(() => {
        this.$refs.projectConfig.init(params.row)
      })
    },
    handleClientContactInfo (params) {
      this.clientContactInfoVisible = true
      this.$nextTick(() => {
        this.$refs.clientContactInfo.init(params.row)
      })
    },
    handleDelete (params) {
      // const id = [params.row.projectId]
      // this.$confirm('确认要删除吗？', '', {
      //   confirmButtonText: '确认',
      //   cancelButtonText: '取消',
      //   cancelButtonClass: 'btn-custom-cancel',
      //   type: 'warning'
      // }).then(() => {
      //   this.$api.contract.deleteContractProjects(id).then(res => {
      //     if (res.success) {
      //       this.$message.success("删除成功")
      //       this.handleQuery()
      //     }
      //   })
      // })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-content {
  width: 100%;
  height: 100%;
  padding: 12px;
  box-sizing: border-box;
}

.content {
  width: 100%;
  height: 100%;
  padding: 12px;
  box-sizing: border-box;
  background-color: #fff;
  overflow: auto;
  text-align: left;
  color: #333;
}
</style>
